module.exports = __webpack_public_path__ + "img/two.490d781a.png";